import React from "react";

export default function NotFound() {
  return (
    <div className="card">
      <h1>404</h1>
      <p>This page was not found.</p>
      <a href="/">Go back home</a>
    </div>
  );
}
